import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HtmlViewerComponent } from 'src/app/popups/html-viewer/html-viewer.component';
import { MessageComponent } from 'src/app/popups/message/message.component';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { CommunicationTemplate, InteractionType, LocalService, PageKey, PlanPurchaseInvoiceInitialization, PlanPurchaseInvoiceStatus, RelationShipRole, Status } from 'src/service/local.service';
import { PlanPurchaseService } from 'src/service/plan-purchase.service';

@Component({
  selector: 'app-plan-purchase',
  templateUrl: './plan-purchase.component.html',
  styleUrl: './plan-purchase.component.scss'
})
export class PlanPurchaseComponent {
  CommunicationTemplate = CommunicationTemplate;
  PlanPurchaseInvoiceStatus = PlanPurchaseInvoiceStatus; PageKey = PageKey; InteractionType = InteractionType;
  lstSectionConfigKeys: string[] = ["common", "table", "plan_purchase"];
  ctryCode: string = ''; businessId: string = ''; b2bId: string = ''; interactionType = 0; interactionTypeForInvoice = 0; maxBodyHeight = 0;
  source: PlanPurchaseInvoiceInitialization; RelationShipRole = RelationShipRole; pageKey = PageKey.PlanPurchaseBusiness;

  IsPrint: boolean = false; printContent: string = ''; fileName: string = ''; isPickBusiness: boolean = false; isOpenSendToPhone: boolean = false;
  selectedId: string = '';
  constructor(public localService: LocalService, private route: ActivatedRoute, private cdr: ChangeDetectorRef, private configurationManagementService: ConfigurationManagementService, private languageManagementService: LanguageManagementService, private planPurchaseService: PlanPurchaseService, private router: Router, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.isPickBusiness = false;
      this.interactionType = routeParams.interactionType;
      this.interactionTypeForInvoice = routeParams.interactionTypeForInvoice;
      this.businessId = routeParams.businessId ?? '';
      this.b2bId = routeParams.b2bId ?? '';
      this.ctryCode = routeParams.ctryCode;
      this.pageKey = PageKey.PlanPurchaseBusiness;

      if (!this.businessId) {
        this.businessId = this.b2bId;
      }

      if (this.route.snapshot.pathFromRoot.length > 0) {
        if (this.route.snapshot.pathFromRoot[0]['_routerState'].url.indexOf('invoice-from-pnixsoft') > -1) {
          this.pageKey = PageKey.InvoiceFromPnixSoft;
        } else if (this.route.snapshot.pathFromRoot[0]['_routerState'].url.indexOf('invoice-to-biz') > -1) {
          this.pageKey = PageKey.InvoiceToBusiness;
        }
      }

      this.configurationManagementService.ensurePageActions(this.pageKey, this.businessId);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, this.businessId);

      if (!this.businessId || this.businessId == '0') {
        if (this.pageKey == PageKey.InvoiceToBusiness) {
          this.isPickBusiness = true;
        } else {
          this.router.navigate(['/sellers' + this.localService.basicParamsString]);
        }
      } else {
        this.onInitiate();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.onLoad();
  }

  isProcessing = false;
  onLoad() {
    if (!this.isProcessing) {
      if (this.localService.isUserHasBusinessRole(this.businessId, RelationShipRole.Admin) || this.interactionType == InteractionType.B2B) {
        this.isProcessing = true;
        if (this.source && this.source.content && this.source.content.paging) {
          this.planPurchaseService.getPlanPurchaseInvoices(this.businessId, this.interactionTypeForInvoice, this.b2bId, this.source.content.paging).subscribe(result => {
            this.source.content = result;
            this.isProcessing = false;
          });
        } else {
          this.planPurchaseService.getPlanPurchaseInvoiceInitialization(this.businessId, this.interactionTypeForInvoice, this.b2bId).subscribe(result => {
            this.source = result;
            this.isProcessing = false;
          });
        }
      }
    }
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.onBuyNewPlan();
      } break;
      case 2: {
        const modalRef = this.modalService.open(MessageComponent);
        modalRef.componentInstance.IsConfirmationType = true;
        modalRef.componentInstance.message = this.localService.languageContent.common.delete_confirmation;
        modalRef.result.then((result) => {
          this.planPurchaseService.setInvoiceStatus(key, PlanPurchaseInvoiceStatus.Cancelled).subscribe(result => {
            this.localService.showInformationByStatus(result.status);
            if (result.status == Status.Success) {
              this.onLoad();
            }
          });
        });
      } break;
      case 3: {
        if (this.route.snapshot.pathFromRoot.length > 0) {
          this.localService.lastUrl = this.route.snapshot.pathFromRoot[0]['_routerState'].url;
        }
        this.router.navigate(['/plan-purchase-detail' + this.localService.basicParamsString, key]);
      } break;
      case 4: {
        this.onOpenInvoice(1, key);
      } break;
      case 5: {
        this.onOpenInvoice(2, key);
      } break;
      case 6: {
        this.router.navigate(['/invoice-to-biz' + this.localService.basicParamsString, this.interactionTypeForInvoice, this.b2bId, key]);
      } break;
      case 7: {
        this.selectedId = key;
        this.isOpenSendToPhone = true;
      } break;
    }
  }

  onBuyNewPlan() {
    this.planPurchaseService.getNewPlanPurchaseInvoice(this.businessId, this.interactionTypeForInvoice, this.b2bId).subscribe(result => {
      this.localService.showInformationByStatus(result.status, result.status != Status.Success);
      if (result.status == Status.Success) {
        this.router.navigate(['/plan-purchase-detail' + this.localService.basicParamsString, result.id]);
      }
    });
  }

  onOpenInvoice(index: number, invoiceId: string) {
    this.planPurchaseService.getInvoice(invoiceId, index == 2).subscribe(result => {
      switch (index) {
        case 1: {
          const modalRef = this.modalService.open(HtmlViewerComponent, { size: 'xl' });
          modalRef.componentInstance.content = result.value;
          modalRef.componentInstance.isPopUp = true;
        } break;
        case 2: {
          this.fileName = result.key;
          this.IsPrint = true;
          this.printContent = result.value;
        } break;
      }
    });
  }

  onPrinted() {
    this.IsPrint = false;
  }
}
